import { EOrganizationProvisioningType } from '@/types';

// Kept as a runtime list so it can back a type guard.
export const CREATE_ORGANIZATION_TABS = [
  'profile',
  'configuration',
  'poc',
  'provisioning',
] as const;
export type TCreateOrganizationTab = (typeof CREATE_ORGANIZATION_TABS)[number];

// Kept as a runtime list so it can back a type guard.
export const PROVISIONING_TYPE_TABS = [
  EOrganizationProvisioningType.SEATS,
  EOrganizationProvisioningType.CONSULTS_PER_MONTH,
] as const;
